import {
  getAppIdByAppName,
  INTEGRATIONS_APPS,
} from 'integrations-lib/constants/AppIds';

export const APPS_WITH_DEFAULT_PORTAL_STATUSES: Partial<
  keyof typeof INTEGRATIONS_APPS
>[] = [INTEGRATIONS_APPS.ADOBE_SIGN, INTEGRATIONS_APPS.DOCUSIGN];

export const APP_IDS_OF_APPS_WITH_DEFAULT_PORTAL_STATUSES =
  APPS_WITH_DEFAULT_PORTAL_STATUSES.map(getAppIdByAppName);

export const hasDefaultPortalStatuses = (appId?: number) => {
  return (
    !!appId && APP_IDS_OF_APPS_WITH_DEFAULT_PORTAL_STATUSES.includes(appId)
  );
};
